import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSite } from "@/lib/site";

const links = [
  { to: "/propiedades", k: "properties" },
  { to: "/#zonas", k: "zones" },
  { to: "/servicios", k: "services" },
  { to: "/#guia", k: "guide" },
  { to: "/#contacto", k: "contact" },
];

export default function Navbar() {
  const { t, lang, setLang } = useSite();
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100" data-testid="site-navbar">
      <div className="container-x h-20 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src="/brand/mark.png" alt="SoloRentaPC logo" className="h-9 w-auto" />
          <span className="font-display text-xl font-extrabold tracking-tight">
            Solo<span className="text-[#FF3333]">Renta</span><span className="text-slate-400 font-semibold text-sm ml-1">PC</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8 text-sm font-medium text-slate-600">
          {links.map((l) => (
            <NavLink key={l.k} to={l.to} className="hover:text-[#FF3333] transition-colors" data-testid={`nav-link-${l.k}`}>{t(l.k)}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button onClick={() => setLang(lang === "es" ? "en" : "es")} className="hidden sm:block text-xs font-semibold text-slate-500 hover:text-slate-900 px-2" data-testid="nav-lang-toggle">
            {lang === "es" ? "EN" : "ES"}
          </button>
          <Link to="/publica-tu-propiedad" className="hidden sm:inline-flex items-center rounded-full bg-[#FF3333] hover:bg-[#E62E2E] text-white text-sm font-semibold px-5 py-2.5 transition-colors shadow-sm" data-testid="nav-publish-button">
            {t("publish")}
          </Link>
          <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menú">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link key={l.k} to={l.to} onClick={() => setOpen(false)} className="text-slate-700 font-medium">{t(l.k)}</Link>
          ))}
          <Link to="/publica-tu-propiedad" onClick={() => setOpen(false)} className="rounded-full bg-[#FF3333] text-white text-center font-semibold py-3" data-testid="nav-mobile-publish">{t("publish")}</Link>
          <button onClick={() => setLang(lang === "es" ? "en" : "es")} className="text-left text-sm text-slate-500">{lang === "es" ? "English" : "Español"}</button>
        </div>
      )}
    </header>
  );
}
